import { graphql } from '../graphql';

export const layersQuery = graphql(`
  query Layers($projectId: ID!) {
    layers(projectId: $projectId) {
      id
      parentLayerId

      name
      description

      type
      root
      metadata

      bbox
      bboxNew
      center

      isHidden
      isLocked

      isEphemeral
      ephemeralExpiresAt
      ephemeralSourceBytes

      propertyAliases {
        property
        alias
      }

      createdAt
      updatedAt

      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        modelOpacity
        modelColorBy
        modelClassColors {
          class
          color
        }
        landxmlCategoryColors {
          surface
          alignment
          parcel
          breakline
          pipe
          structure
        }
        landxmlSurfaceColorMode
        landxmlSurfaceColormap
        surfaceDifferenceColormap
        scalarRangeMin
        scalarRangeMax
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
        vectorLineRenderAsPipe
        vectorLineWidth
        rasterOpacity
        rasterContrast
        rasterSaturation
        rasterBrightness
        offsetX
        offsetY
        offsetZ
        rotationX
        rotationY
        rotationZ
        sectionOverlays {
          id
          kind
          layerId
          ref
          pcMethod
          hidden
        }
      }
    }
  }
`);

export const createLayerMutation = graphql(`
  mutation CreateLayer($input: CreateLayerInput!) {
    createLayer(input: $input) {
      id
    }
  }
`);

export const updateLayerMutation = graphql(`
  mutation UpdateLayer($input: UpdateLayerInput!) {
    updateLayer(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`);

export const deleteLayerMutation = graphql(`
  mutation DeleteLayer($id: ID!) {
    deleteLayer(id: $id)
  }
`);

export const layerQuery = graphql(`
  query Layer($id: ID!) {
    layer(id: $id) {
      id
      parentLayerId

      name
      description

      type
      root
      metadata

      bbox
      bboxNew
      center

      isHidden
      isLocked

      createdAt
      updatedAt

      sourceAttachment {
        batchId
        filename
        contentLength
        createdAt
      }

      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        modelOpacity
        modelColorBy
        modelClassColors {
          class
          color
        }
        landxmlCategoryColors {
          surface
          alignment
          parcel
          breakline
          pipe
          structure
        }
        landxmlSurfaceColorMode
        landxmlSurfaceColormap
        surfaceDifferenceColormap
        scalarRangeMin
        scalarRangeMax
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        imageBrightness
        imageContrast
        imageSaturation
        imageOpacity
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
        vectorLineRenderAsPipe
        vectorLineWidth
        rasterOpacity
        rasterContrast
        rasterSaturation
        rasterBrightness
        offsetX
        offsetY
        offsetZ
        rotationX
        rotationY
        rotationZ
        sectionOverlays {
          id
          kind
          layerId
          ref
          pcMethod
          hidden
        }
      }
    }
  }
`);

export const updateLayerSettingsMutation = graphql(`
  mutation UpdateLayerSettings($id: ID!, $input: LayerSettingsInput!) {
    updateLayerSettings(id: $id, input: $input)
  }
`);

export const updateLayersSettingsMutation = graphql(`
  mutation UpdateLayersSettings($input: [UpdateLayerSettingsBatchInput!]!) {
    updateLayersSettings(input: $input)
  }
`);

export const layerSettingsQuery = graphql(`
  query LayerSettings($id: ID!) {
    layer(id: $id) {
      id
      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        modelOpacity
        modelColorBy
        modelClassColors {
          class
          color
        }
        landxmlCategoryColors {
          surface
          alignment
          parcel
          breakline
          pipe
          structure
        }
        landxmlSurfaceColorMode
        landxmlSurfaceColormap
        surfaceDifferenceColormap
        scalarRangeMin
        scalarRangeMax
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        imageBrightness
        imageContrast
        imageSaturation
        imageOpacity
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
        vectorLineRenderAsPipe
        vectorLineWidth
        rasterOpacity
        rasterContrast
        rasterSaturation
        rasterBrightness
        offsetX
        offsetY
        offsetZ
        rotationX
        rotationY
        rotationZ
        sectionOverlays {
          id
          kind
          layerId
          ref
          pcMethod
          hidden
        }
      }
    }
  }
`);

export const layerPropertiesQuery = graphql(`
  query LayerProperties($layerId: ID!) {
    layerProperties(layerId: $layerId)
  }
`);

export const layerPropertyValuesQuery = graphql(`
  query LayerPropertyValues($layerId: ID!) {
    layerPropertyValues(layerId: $layerId) {
      property
      values
    }
  }
`);

export const quickUploadLayerMutation = graphql(`
  mutation QuickUploadLayer($input: QuickUploadLayerInput!) {
    quickUploadLayer(input: $input) {
      layer {
        id
        name
        type
        isEphemeral
        ephemeralExpiresAt
        ephemeralSourceBytes
      }
      expiresAt
    }
  }
`);

export const touchEphemeralLayersMutation = graphql(`
  mutation TouchEphemeralLayers($layerIds: [ID!]!) {
    touchEphemeralLayers(layerIds: $layerIds)
  }
`);

export const refreshWmsLayerMutation = graphql(`
  mutation RefreshWmsLayer($layerId: ID!) {
    refreshWmsLayer(layerId: $layerId) {
      id
      name
      type
      metadata
      subLayers {
        id
        name
        type
        metadata
        bbox
        isHidden
      }
    }
  }
`);

export const materializeSectionOverlaysMutation = graphql(`
  mutation MaterializeSectionOverlays($layerId: ID!) {
    materializeSectionOverlays(layerId: $layerId)
  }
`);

export const generateLayerMap2dMutation = graphql(`
  mutation GenerateLayerMap2d($layerId: ID!) {
    generateLayerMap2d(layerId: $layerId)
  }
`);
